import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Category from "@/components/Category";
import useGNBHandler from "@/components/common/GNB/useGNBHandler";
import useLogout from "@/components/common/GNB/useLogout";
import { Hamburger, User } from "@/components/icon/IconList";
import { GNBSideSheet } from "@/components/SideSheets/GNBSideSheet";
import { useSideCategoryMenuStore } from "@/components/SideSheets/store/useCategoryMenuStore";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { LOGIN_PAGE, MYPAGE_COUPONS, MYPAGE_PACKAGES_INDEX_PAGE, MYPAGE_PASSES, MYPAGE_STORES_PRODUCTS_INDEX, REGISTRATION_PAGE, SOLVOOK_WRITE_STUDIO } from "@/settings/constant";
import { CommonGNB, GNB, GNBMenuIcon } from "@bookips/solvook-ui-library";
import { useRouter } from "next/router";
import { useMemo } from "react";
import Headroom from "react-headroom";
import { getCurrentCartQuery } from "src/api/booksCart";
import { SearchRequestForm } from "../../../containers/Header/SearchRequestForm";
const MarketGNB = ()=>{
    const { handleLogout , isLoggedIn  } = useLogout();
    const { data: cartCounter  } = getCurrentCartQuery({
        enabled: isLoggedIn,
        params: {
            cartType: "separate"
        }
    });
    const { handleDropdownClick , handleCategoryButton , handlePageMove , handleSideMenu , isOpenSideMenu , labName  } = useGNBHandler();
    const { isOpenSideMenu: isOpenCategorySideMenu , closeSideMenu  } = useSideCategoryMenuStore();
    return /*#__PURE__*/ _jsxs(HeadroomWrapper, {
        children: [
            /*#__PURE__*/ _jsx(CommonGNB, {
                onClickLogo: ()=>mixpanelEvent("Logo Clicked"),
                isLoggedIn: isLoggedIn,
                loginButtonGroup: {
                    onLoginClick: ()=>handlePageMove(LOGIN_PAGE, true),
                    onSignUpClick: ()=>handlePageMove(REGISTRATION_PAGE, true)
                },
                category: {
                    onClick: handleCategoryButton,
                    openCategory: isOpenSideMenu
                },
                menu: {
                    cart: (path)=>handlePageMove(path, false),
                    expert: ()=>{
                        mixpanelEvent("GNB Button Clicked", {
                            "Button Type": "엑스퍼트",
                            "Button Name": "엑스퍼트",
                            "Button URL": SOLVOOK_WRITE_STUDIO
                        }, {
                            send_immediately: true
                        });
                        handlePageMove(SOLVOOK_WRITE_STUDIO, false);
                    },
                    library: (path)=>handlePageMove(path, false),
                    cartBadge: cartCounter === null || cartCounter === void 0 ? void 0 : cartCounter.lineItemsCount,
                    fixedMobileMenu: {
                        loggedIn: {
                            onClick: handleSideMenu,
                            icon: /*#__PURE__*/ _jsx(GNBMenuIcon, {
                                Element: Hamburger
                            }),
                            label: "메뉴"
                        },
                        loggedOut: {
                            onClick: handleSideMenu,
                            icon: /*#__PURE__*/ _jsx(GNBMenuIcon, {
                                Element: Hamburger
                            }),
                            label: "메뉴"
                        }
                    },
                    dropdown: /*#__PURE__*/ _jsx(GNB.MenuButtonWithDropdown, {
                        label: "마이페이지",
                        menuItems: [
                            ...labName ? [
                                {
                                    label: "브랜드 홈",
                                    onClick: ()=>handleDropdownClick("/@".concat(labName))
                                }
                            ] : [],
                            {
                                label: "패키지 보관함",
                                onClick: ()=>handleDropdownClick(MYPAGE_PACKAGES_INDEX_PAGE)
                            },
                            {
                                label: "쿠폰 관리",
                                onClick: ()=>handleDropdownClick(MYPAGE_COUPONS)
                            },
                            {
                                label: "이용권 관리",
                                onClick: ()=>handleDropdownClick(MYPAGE_PASSES)
                            },
                            {
                                label: "자료 판매",
                                onClick: ()=>handleDropdownClick(MYPAGE_STORES_PRODUCTS_INDEX)
                            },
                            {
                                label: "로그아웃",
                                onClick: ()=>handleLogout()
                            }
                        ],
                        children: /*#__PURE__*/ _jsx(GNBMenuIcon, {
                            Element: User
                        })
                    })
                },
                searchTextField: /*#__PURE__*/ _jsx(SearchRequestForm, {})
            }),
            isOpenCategorySideMenu && /*#__PURE__*/ _jsx(Category, {
                onClose: closeSideMenu
            }),
            /*#__PURE__*/ _jsx(GNBSideSheet, {
                onLogout: handleLogout
            })
        ]
    });
};
export default MarketGNB;
const HeadroomWrapper = (param)=>{
    let { children  } = param;
    const { pathname  } = useRouter();
    const { isHidden  } = useMemo(()=>{
        return {
            isHidden: pathname === "/products/[id]" || pathname.includes("labs")
        };
    }, [
        pathname
    ]);
    return isHidden ? /*#__PURE__*/ _jsx(Headroom, {
        disable: isHidden,
        style: {
            zIndex: "800"
        },
        children: children
    }) : /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
